<div class="email" ngStyle.lt-md="margin-top: 61px; height: calc(100vh - 60px)">
  <div class="content" ngStyle.lt-sm="padding: 20px; width: calc(95% - 40px)">
    <ng-container *ngIf="isSuccess">
      <img src="./assets/icons/success.svg" style="width: 50px; height: 50px"
           ngStyle.lt-sm="width: 30px; height: 30px">
      <h4 style="font-size: 16px" ngStyle.lt-md="font-size: 20px"
          ngStyle.lt-sm="font-size: 16px">Congratulations!</h4>
      <p style="font-family: 'Inter Regular'; font-size: 14px"
         ngStyle.lt-sm="font-size: 14px">Your email has been successfully verified. Now you may log in.</p>
      <button style="margin-top: 20px" (click)="login()">Log in</button>
    </ng-container>
    <ng-container *ngIf="isSuccess == false">
      <img src="./assets/icons/fail.svg" style="width: 50px;height: 50px"
           ngStyle.lt-sm="width: 30px; height: 30px">
      <h4 style="font-size: 16px" ngStyle.lt-md="font-size: 20px"
          ngStyle.lt-sm="font-size: 16px">Sorry, we cannot verify your email</h4>
      <p></p>
      <!--      <div style="display: flex; justify-content: center; align-items: center; margin-top: 20px">-->
      <!--        <input [(ngModel)]="code">-->
      <!--        <img [src]="verifyCodeUrl" style="width: 80px; margin-left: 10px; cursor: pointer"-->
      <!--             (click)="changeCode()">-->
      <!--      </div>-->
      <!--      <button (click)="resend()"-->
      <!--              style="margin-top: 20px; font-size: 14px; font-family: 'Inter Regular'"-->
      <!--              [ngClass]="{'deactivated': remainTimeInSeconds > 0 || isResending || code === ''}"-->
      <!--              [disabled]="remainTimeInSeconds > 0 || isResending || code === ''">-->
      <!--        {{isResending ? ('resending' | translate) :-->
      <!--        (remainTimeInSeconds > 0 ? ('resend' | translate) + '(' + remainTimeInSeconds + ' ' + ('s'| translate) + ')'-->
      <!--          : ('resend' | translate))}}-->
      <!--      </button>-->
      <!--      <div style="margin-top: 20px">-->
      <!--        <p *ngIf="incorrectCode"-->
      <!--           style="font-size: 12px; font-family: 'Inter Regular'; color: #c80000">{{'incorrectCode' | translate}}</p>-->
      <!--        <div *ngIf="successSent"-->
      <!--             style="display: flex; justify-content: center; align-items: center; font-size: 12px; font-family: 'Inter Regular'">-->
      <!--          <img src="../../../assets/image/success.svg" style="width: 15px; height: 15px; margin-right: 10px">-->
      <!--          {{'verify_sent' | translate}}-->
      <!--        </div>-->
      <!--        <p *ngIf="successSent === false"-->
      <!--           style="font-size: 12px; font-family: 'Inter Regular'; color: #c80000">{{'fail_resend' | translate}}</p>-->
      <!--      </div>-->
    </ng-container>
  </div>
</div>
